import { Logger } from '@nextgen-web-framework/core';
import { handleRequest } from '../../transformers';
// eslint-disable-next-line unused-imports/no-unused-imports
import { type GenericObject, IProduct, type CustomRequestOptions } from '../../types';
import { extractKeysFromJson, logObject } from '../../utils';
import { getContentStackReqObj } from '../config/contentStackEndPoints';
import { FetchEntriesResponse } from '../models/pdp/models/FetchEntriesResponse';

const API_VERSION_V1 = 'v1';

const loggerInstance = Logger.getInstance(logObject('contentStackApi'));

type IContentStackApi = {
  productData: IProduct;
  langauge?: string;
  options?: CustomRequestOptions;
};

export const contentStackApi = {
  async getProductDetailsContentStackData({
    productData,
    langauge = '',
    options = {},
  }: IContentStackApi): Promise<GenericObject[] | Response> {
    const { id, pdpLayoutJson, pcmMetadata, isBundle } = productData;
    if (!pdpLayoutJson) {
      loggerInstance.error('Missing pdp layout json. Please check arguments for a valid pdp layout json.');
      throw new Error('Null argument. Please retry with valid productData.');
    }

    try {
      const requestObj = getContentStackReqObj(API_VERSION_V1, isBundle);
      let errorResponse: Response | undefined;
      const refBlocks = ['product_details_content']; // Reason for hardcoding is Refblock keys are related to RefTypes. Also, if any other key will come in the refBlocks, then json will be different. For example, 'product_details_content' is mapped with pdpLayoutJson. So in future, in the refBlocks, suppose 'product_price' will come, then json will be different and it will be confirmed by backend team.

      const body = [
        {
          uid: pcmMetadata?.pcmEntryUid,
          id: id,
          refBlocks,
          refTypes: [...extractKeysFromJson(pdpLayoutJson, 'product_details_content')],
          locale: langauge,
        },
      ];

      requestObj.body = body as unknown as BodyInit;

      options.errorHandlers = {
        default: (res: Response) => {
          errorResponse = res;
        },
      };

      const response = await handleRequest<FetchEntriesResponse>(requestObj, options);
      let productDetailsContent: GenericObject[] = [];
      if (response.entries && response.entries?.length > 0) {
        productDetailsContent =
          // The key name `product_details_content` is expected structure coming from CS API
          // eslint-disable-next-line @typescript-eslint/naming-convention
          (response.entries[0].data as { product_details_content: [] })?.product_details_content ?? [];
      }
      return errorResponse ? errorResponse : productDetailsContent;
    } catch (err) {
      loggerInstance.error(`Failed to load product details data from CS. Message: ${err}`);
      throw err;
    }
  },
};

export default contentStackApi;
export type { IContentStackApi };
